import { create } from 'zustand';

export type PrimesBreadcrumbContext = {
  tamDisplayName?: string;
  tamEmail?: string;
  selectedYear?: string;
  referenceDate?: Date;
};

export interface BreadcrumbState {
  /**
   * Libellés dynamiques du fil d'Ariane, indexés par chemin cumulatif
   * (ex: '/missions-freelance/recXXX' -> 'CTO - Loïc Calvy chez Hermès').
   * Une page peut enregistrer un libellé lisible pour remplacer le libellé générique ("Détail").
   */
  labels: Record<string, string>;
  /** Contexte primes (nom TAM, année, mois) pour le fil d'Ariane des parcours TAM / C-Level. */
  primesContext: PrimesBreadcrumbContext | null;
  setLabel: (path: string, label: string) => void;
  clearLabel: (path: string) => void;
  setPrimesContext: (context: PrimesBreadcrumbContext | null) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>()((set) => ({
  labels: {},
  primesContext: null,
  setLabel: (path, label) =>
    set((state) => (state.labels[path] === label ? state : { labels: { ...state.labels, [path]: label } })),
  clearLabel: (path) =>
    set((state) => {
      if (!(path in state.labels)) return state;
      const next = { ...state.labels };
      delete next[path];
      return { labels: next };
    }),
  setPrimesContext: (context) =>
    set((state) => {
      if (state.primesContext === context) return state;
      return { primesContext: context };
    }),
}));
